import React from "react";
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"

const ModalAccount = (props) => {
    return (
        <Modal fullscreen={true} show={props.visible} onHide={()=>props.setVisible(false)}>
            <Modal.Header className="custom-modal-header" closeButton>
                <Modal.Title>Selecciona la cuenta del Área</Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                {props.accounts}
            </Modal.Body>
        </Modal>
    )
}

ModalAccount.propTypes = {
    accounts: PropTypes.array,    
    visible: PropTypes.bool,
    setVisible: PropTypes.func,
}

export default ModalAccount